import { Button, Tooltip } from '@chronosphereio/chrono-ui';
import { PlusBoxOutline as AddGroupIcon } from 'mdi-material-ui';
import { DASHBOARD_TOOLTIP_TEXT } from '../../constants';
import { useDashboardActions } from '../../context';

export const AddGroupButton = () => {
  const { openAddPanelGroup } = useDashboardActions();

  return (
    <Tooltip Content={DASHBOARD_TOOLTIP_TEXT.addGroup}>
      <Button
        StartIcon={<AddGroupIcon />}
        onClick={openAddPanelGroup}
        aria-label={DASHBOARD_TOOLTIP_TEXT.addGroup}
        sx={{
          whiteSpace: 'nowrap',
        }}
      >
        Panel Group
      </Button>
    </Tooltip>
  );
};
